;
define("product_list_list_details.tpl", function(){});

